const faqs = [
  {
    question: "Does New Hampshire have its own regional passport agency?",
    answer:
      "New Hampshire does not have a state-level passport agency. The nearest regional passport agency for most of New Hampshire is the Boston Passport Agency, located in downtown Boston. Travelers from the northern parts of the state may also consider the New York Passport Agency depending on appointment availability.",
  },
  {
    question: "How fast can I get a passport in New Hampshire?",
    answer:
      "With Fast Passport Center's courier service, New Hampshire travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in New Hampshire?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, town clerk, or municipal office). Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which New Hampshire airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major New Hampshire departure points include Manchester-Boston Regional (MHT), Portsmouth International (PSM), and Lebanon Municipal (LEB). Most international flights from New Hampshire connect through Boston Logan.",
  },
  {
    question: "Can I renew by mail from New Hampshire?",
    answer:
      "Yes. If your previous passport was issued within the last 15 years when you were age 16 or older, and it is not significantly damaged, you can renew by mail using Form DS-82. This is the most convenient option for most New Hampshire residents.",
  },
  {
    question: "Where is the best place to get a passport photo in New Hampshire?",
    answer:
      "CVS, Walgreens, and Walmart locations across New Hampshire offer passport photo services. The UPS Store and FedEx Office also provide photos and can handle overnight shipping of your application. Most chain locations in Manchester, Nashua, Concord, and Portsmouth have walk-in availability.",
  },
];

export { faqs };

export default function NewHampshireFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            New Hampshire Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of New Hampshire.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}